import * as ng from '@angular/core';
import {animate, style, transition, trigger, state} from "@angular/animations";
import {Component} from '@angular/core';
import {environment} from '../../../env/environment';
import {LiveUserAuthority} from '../../../lib/entity/live-user-authority';

@Component({
  selector: 'maglive-index-header',
  styleUrls: ['./index-header.component.scss'],
  templateUrl: './index-header.component.html',
  animations: [
    trigger('toggleMenu', [
      state('open', style({right: '0px'})),
      state('closed', style({right: '-300px'})),
      transition('open <=> closed', [
        animate('200ms ease-in')
      ]),
    ]),
  ],
})
export class IndexHeaderComponent {
  public baseURL = environment.baseURL;
  public loginCallbackURL = environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href;
  public registerCallbackURL = environment.baseURL.mag2mypage + 'entry/UserRegistTerms.do?ref=' + window.location.href;
  menuOpen = false;
  pointManageUrl: string

  @ng.Input()
  public authority: LiveUserAuthority | 'NOT_LOGIN' | undefined;

  ngOnInit() {
    const header = document.getElementById('header-pc')
    header.addEventListener('mouseover', (ev) => {
      header.style.opacity = '1'
    })
    window.addEventListener('scroll', this.onWindowScroll)

    if (environment.name === 'local') {
      this.pointManageUrl = window.location.href + 'point'
    } else {
      this.pointManageUrl = this.baseURL.magliveWeb + 'point'
    }
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onWindowScroll)
  }

  onWindowScroll() {
    const header = document.getElementById('header-pc')
    header.style.opacity = window.scrollY < 30 ? '1' : '0.3'
  }

  onMenuToggled() {
    this.menuOpen = !this.menuOpen
  }

}
